<div class="admin-contact-support">
  <div class="page-header">
    <div class="header-content">
      <div class="header-left">
        <button class="btn-back" (click)="goBack()">
          <span class="back-icon">⬅️</span>
          Back to Admin
        </button>
        <div class="title-section">
          <h1 class="page-title">Contact Support Management</h1>
          <p class="page-subtitle">
            Manage customer inquiries and support tickets
          </p>
        </div>
      </div>
      <div class="header-actions">
        <button class="btn-refresh" (click)="onRefresh()" [disabled]="loading">
          <span class="refresh-icon">🔄</span>
          <span>Refresh</span>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="stats" class="stats-section">
    <div class="stats-grid">
      <div class="stat-card total">
        <div class="stat-icon">📊</div>
        <div class="stat-content">
          <div class="stat-number">{{ stats.total }}</div>
          <div class="stat-label">Total Submissions</div>
        </div>
      </div>
      <div class="stat-card pending">
        <div class="stat-icon">⏳</div>
        <div class="stat-content">
          <div class="stat-number">{{ stats.pending }}</div>
          <div class="stat-label">Pending</div>
        </div>
      </div>
      <div class="stat-card in-progress">
        <div class="stat-icon">🔄</div>
        <div class="stat-content">
          <div class="stat-number">{{ stats.in_progress }}</div>
          <div class="stat-label">In Progress</div>
        </div>
      </div>
      <div class="stat-card resolved">
        <div class="stat-icon">✅</div>
        <div class="stat-content">
          <div class="stat-number">{{ stats.resolved }}</div>
          <div class="stat-label">Resolved</div>
        </div>
      </div>
      <div class="stat-card response-time" *ngIf="stats.avg_resolution_hours">
        <div class="stat-icon">⏱️</div>
        <div class="stat-content">
          <div class="stat-number">
            {{ stats.avg_resolution_hours.toFixed(1) }}h
          </div>
          <div class="stat-label">Avg Response Time</div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="messages.success" class="alert alert-success">
    <span>{{ messages.success }}</span>
    <button class="alert-close" (click)="dismissMessage('success')">×</button>
  </div>

  <div *ngIf="messages.error" class="alert alert-error">
    <span>{{ messages.error }}</span>
    <button class="alert-close" (click)="dismissMessage('error')">×</button>
  </div>

  <div class="filters-section">
    <div class="filters-row">
      <div class="filter-group">
        <label>Status:</label>
        <select
          [(ngModel)]="filters.status"
          (ngModelChange)="onFilterChange()"
          class="filter-select"
        >
          <option *ngFor="let option of statusOptions" [value]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>

      <div class="filter-group">
        <label>Priority:</label>
        <select
          [(ngModel)]="filters.priority"
          (ngModelChange)="onFilterChange()"
          class="filter-select"
        >
          <option *ngFor="let option of priorityOptions" [value]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>

      <div class="filter-group">
        <label>Assigned To:</label>
        <select
          [(ngModel)]="filters.assignedTo"
          (ngModelChange)="onFilterChange()"
          class="filter-select"
        >
          <option value="">All Admins</option>
          <option value="unassigned">Unassigned</option>
          <option *ngFor="let admin of availableAdmins" [value]="admin.id">
            {{ admin.first_name }} {{ admin.last_name }}
          </option>
        </select>
      </div>

      <div class="filter-group search-group">
        <label>Search:</label>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (input)="onSearch($event)"
          placeholder="Search by name, email, subject, or message..."
          class="search-input"
        />
      </div>
    </div>
  </div>

  <div *ngIf="showBulkActions" class="bulk-actions-bar">
    <div class="bulk-info">
      <span class="selected-count">{{ getSelectedCount() }} selected</span>
    </div>
    <div class="bulk-actions">
      <button
        class="btn-bulk-action update"
        (click)="bulkUpdate()"
        [disabled]="bulkProcessing"
      >
        <span class="btn-icon">📝</span>
        Bulk Update
      </button>
      <button class="btn-bulk-action clear" (click)="clearSelection()">
        <span class="btn-icon">🗑️</span>
        Clear Selection
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading contact submissions...</p>
  </div>

  <div *ngIf="error && !loading" class="error-container">
    <div class="error-card">
      <h3>Error Loading Submissions</h3>
      <p>{{ error }}</p>
      <button class="btn-retry" (click)="onRefresh()">Try Again</button>
    </div>
  </div>

  <div *ngIf="!loading && !error" class="submissions-section">
    <div class="submissions-header">
      <div class="submissions-count">
        Showing {{ submissions.length }} of {{ totalItems }} submissions
        <span class="page-info"
          >(Page {{ currentPage }} of {{ totalPages }})</span
        >
      </div>
      <div class="items-per-page">
        <label>Items per page:</label>
        <select
          [(ngModel)]="itemsPerPage"
          (ngModelChange)="onFilterChange()"
          class="page-select"
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
    </div>

    <div class="table-container">
      <table class="submissions-table">
        <thead>
          <tr>
            <th class="checkbox-col">
              <input
                type="checkbox"
                [checked]="isAllSelected()"
                (change)="onSelectAll($event)"
                class="select-all-checkbox"
              />
            </th>
            <th>Customer</th>
            <th>Subject & Message</th>
            <th>Status</th>
            <th>Priority</th>
            <th>Assigned To</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let submission of submissions; trackBy: trackBySubmissionId"
            class="submission-row"
            [class.selected]="isSelected(submission.id)"
          >
            <td class="checkbox-col">
              <input
                type="checkbox"
                [checked]="isSelected(submission.id)"
                (change)="onSubmissionSelect(submission.id, $event)"
                class="submission-checkbox"
              />
            </td>

            <td class="customer-col">
              <div class="customer-info">
                <div class="customer-name">{{ submission.name }}</div>
                <div class="customer-email">{{ submission.email }}</div>
                <div *ngIf="submission.phone" class="customer-phone">
                  {{ submission.phone }}
                </div>
              </div>
            </td>

            <td class="message-col">
              <div
                class="message-preview"
                (click)="viewSubmissionDetails(submission)"
              >
                <div class="subject-line">
                  {{ submission.subject || "No subject" }}
                </div>
                <div class="message-text">
                  {{ submission.message.substring(0, 100)
                  }}{{ submission.message.length > 100 ? "..." : "" }}
                </div>
                <div class="message-meta">
                  <span class="response-count"
                    >{{ submission.response_count }} responses</span
                  >
                  <span
                    *ngIf="hasUserReplies(submission)"
                    class="user-reply-indicator"
                  >
                    💬 Customer replied
                  </span>
                </div>
              </div>
            </td>

            <td class="status-col">
              <span
                class="status-badge"
                [class]="getStatusClass(submission.status)"
              >
                {{ formatStatus(submission.status) }}
              </span>
            </td>

            <td class="priority-col">
              <span
                class="priority-badge"
                [class]="getPriorityClass(submission.priority)"
              >
                {{ formatPriority(submission.priority) }}
              </span>
            </td>

            <td class="assigned-col">
              <div class="assigned-info">
                {{
                  getAdminName(
                    submission.assigned_admin_first_name,
                    submission.assigned_admin_last_name
                  )
                }}
              </div>
            </td>

            <td class="date-col">
              <div class="date-info">
                <div class="created-date">
                  {{ formatDate(submission.created_at) }}
                </div>
                <div *ngIf="submission.responded_at" class="responded-date">
                  Responded: {{ formatDate(submission.responded_at) }}
                </div>
              </div>
            </td>

            <td class="actions-col">
              <div class="action-buttons">
                <button
                  class="btn-action view"
                  (click)="viewSubmissionDetails(submission)"
                  title="View Details"
                >
                  👁️
                </button>
                <button
                  class="btn-action respond"
                  (click)="respondToSubmission(submission)"
                  title="Respond"
                  [disabled]="processing"
                >
                  💬
                </button>
                <div class="action-dropdown">
                  <select
                    (change)="onStatusChange(submission, $event)"
                    class="status-dropdown"
                    [disabled]="processing"
                  >
                    <option value="">Status...</option>
                    <option value="pending">Pending</option>
                    <option value="in_progress">In Progress</option>
                    <option value="resolved">Resolved</option>
                    <option value="closed">Closed</option>
                  </select>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="submissions.length === 0" class="empty-state">
      <div class="empty-content">
        <div class="empty-icon">📧</div>
        <h3>No Submissions Found</h3>
        <p>No contact submissions match your current filters.</p>
      </div>
    </div>

    <div *ngIf="totalPages > 1" class="pagination">
      <button
        class="btn-page"
        [disabled]="currentPage === 1"
        (click)="onPageChange(currentPage - 1)"
      >
        ← Previous
      </button>

      <button
        *ngIf="shouldShowEllipsis('start')"
        class="btn-page"
        (click)="onPageChange(1)"
      >
        1
      </button>

      <span *ngIf="shouldShowEllipsis('start')" class="pagination-ellipsis"
        >...</span
      >

      <button
        *ngFor="let page of getPageNumbers()"
        class="btn-page"
        [class.active]="page === currentPage"
        (click)="onPageChange(page)"
      >
        {{ page }}
      </button>

      <span *ngIf="shouldShowEllipsis('end')" class="pagination-ellipsis"
        >...</span
      >

      <button
        *ngIf="shouldShowEllipsis('end')"
        class="btn-page"
        (click)="onPageChange(totalPages)"
      >
        {{ totalPages }}
      </button>

      <button
        class="btn-page"
        [disabled]="currentPage === totalPages"
        (click)="onPageChange(currentPage + 1)"
      >
        Next →
      </button>
    </div>
  </div>

  <div
    *ngIf="showResponseModal"
    class="modal-overlay"
    (click)="closeResponseModal()"
  >
    <div class="modal-content large" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Respond to Inquiry</h3>
        <button class="modal-close" (click)="closeResponseModal()">×</button>
      </div>

      <div class="modal-body" *ngIf="selectedSubmissionForResponse">
        <div class="customer-summary">
          <h4>Customer: {{ selectedSubmissionForResponse.name }}</h4>
          <p>
            <strong>Email:</strong> {{ selectedSubmissionForResponse.email }}
          </p>
          <p *ngIf="selectedSubmissionForResponse.phone">
            <strong>Phone:</strong> {{ selectedSubmissionForResponse.phone }}
          </p>
          <p>
            <strong>Subject:</strong>
            {{ selectedSubmissionForResponse.subject || "No subject" }}
          </p>
        </div>

        <div class="form-group">
          <label>Response Type:</label>
          <div class="radio-group">
            <label class="radio-item">
              <input
                type="radio"
                name="responseType"
                value="email"
                [(ngModel)]="responseType"
              />
              <span>Email Response</span>
            </label>
            <label class="radio-item">
              <input
                type="radio"
                name="responseType"
                value="phone"
                [(ngModel)]="responseType"
              />
              <span>Phone Call</span>
            </label>
            <label class="radio-item">
              <input
                type="radio"
                name="responseType"
                value="internal_note"
                [(ngModel)]="responseType"
              />
              <span>Internal Note</span>
            </label>
          </div>
        </div>

        <div class="form-group" *ngIf="responseType === 'email'">
          <label>
            <input type="checkbox" [(ngModel)]="isSentToCustomer" />
            Send to customer
          </label>
        </div>

        <div
          class="form-group"
          *ngIf="responseType === 'email' && isSentToCustomer"
        >
          <label for="email-subject">Email Subject:</label>
          <input
            id="email-subject"
            type="text"
            [(ngModel)]="emailSubject"
            class="form-input"
            placeholder="Enter email subject..."
          />
        </div>

        <div class="form-group">
          <label for="response-text">
            {{
              responseType === "email"
                ? "Email"
                : responseType === "phone"
                ? "Call Notes"
                : "Internal Note"
            }}:
          </label>
          <textarea
            id="response-text"
            [(ngModel)]="responseText"
            placeholder="Enter your response..."
            class="form-textarea"
            rows="6"
            required
          ></textarea>
        </div>
      </div>

      <div class="modal-actions">
        <button
          class="btn-modal cancel"
          (click)="closeResponseModal()"
          [disabled]="processing"
        >
          Cancel
        </button>
        <button
          class="btn-modal primary"
          (click)="confirmResponse()"
          [disabled]="processing || !responseText.trim()"
        >
          <span *ngIf="processing">Sending...</span>
          <span *ngIf="!processing">Send Response</span>
        </button>
      </div>
    </div>
  </div>

  <div
    *ngIf="showBulkUpdateModal"
    class="modal-overlay"
    (click)="closeBulkUpdateModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Bulk Update Submissions</h3>
        <button class="modal-close" (click)="closeBulkUpdateModal()">×</button>
      </div>

      <div class="modal-body">
        <p>Update {{ getSelectedCount() }} selected submission(s):</p>

        <div class="form-group">
          <label for="bulk-status">Status:</label>
          <select
            id="bulk-status"
            [(ngModel)]="bulkUpdateData.status"
            class="form-select"
          >
            <option value="">Keep current</option>
            <option value="pending">Pending</option>
            <option value="in_progress">In Progress</option>
            <option value="resolved">Resolved</option>
            <option value="closed">Closed</option>
          </select>
        </div>

        <div class="form-group">
          <label for="bulk-priority">Priority:</label>
          <select
            id="bulk-priority"
            [(ngModel)]="bulkUpdateData.priority"
            class="form-select"
          >
            <option value="">Keep current</option>
            <option value="low">Low</option>
            <option value="normal">Normal</option>
            <option value="high">High</option>
            <option value="urgent">Urgent</option>
          </select>
        </div>

        <div class="form-group">
          <label for="bulk-assigned">Assign To:</label>
          <select
            id="bulk-assigned"
            [(ngModel)]="bulkUpdateData.assigned_to"
            class="form-select"
          >
            <option value="">Keep current</option>
            <option value="null">Unassigned</option>
            <option *ngFor="let admin of availableAdmins" [value]="admin.id">
              {{ admin.first_name }} {{ admin.last_name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="bulk-notes">Internal Notes:</label>
          <textarea
            id="bulk-notes"
            [(ngModel)]="bulkUpdateData.internal_notes"
            placeholder="Add internal notes..."
            class="form-textarea"
            rows="3"
          ></textarea>
        </div>
      </div>

      <div class="modal-actions">
        <button
          class="btn-modal cancel"
          (click)="closeBulkUpdateModal()"
          [disabled]="bulkProcessing"
        >
          Cancel
        </button>
        <button
          class="btn-modal primary"
          (click)="confirmBulkUpdate()"
          [disabled]="bulkProcessing"
        >
          <span *ngIf="bulkProcessing">Updating...</span>
          <span *ngIf="!bulkProcessing">Update Selected</span>
        </button>
      </div>
    </div>
  </div>

  <div
    *ngIf="showSubmissionDetailsModal && selectedSubmissionDetails"
    class="modal-overlay"
    (click)="closeSubmissionDetailsModal()"
  >
    <div class="modal-content large" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Submission Details</h3>
        <button class="modal-close" (click)="closeSubmissionDetailsModal()">
          ×
        </button>
      </div>

      <div class="modal-body">
        <div class="submission-details">
          <div class="details-section">
            <h4>Customer Information</h4>
            <div class="details-grid">
              <div class="detail-item">
                <label>Name:</label>
                <span>{{ selectedSubmissionDetails.submission.name }}</span>
              </div>
              <div class="detail-item">
                <label>Email:</label>
                <span>{{ selectedSubmissionDetails.submission.email }}</span>
              </div>
              <div
                class="detail-item"
                *ngIf="selectedSubmissionDetails.submission.phone"
              >
                <label>Phone:</label>
                <span>{{ selectedSubmissionDetails.submission.phone }}</span>
              </div>
              <div class="detail-item">
                <label>Subject:</label>
                <span>{{
                  selectedSubmissionDetails.submission.subject || "No subject"
                }}</span>
              </div>
              <div class="detail-item">
                <label>Status:</label>
                <span
                  class="status-badge"
                  [class]="
                    getStatusClass(selectedSubmissionDetails.submission.status)
                  "
                >
                  {{
                    formatStatus(selectedSubmissionDetails.submission.status)
                  }}
                </span>
              </div>
              <div class="detail-item">
                <label>Priority:</label>
                <span
                  class="priority-badge"
                  [class]="
                    getPriorityClass(
                      selectedSubmissionDetails.submission.priority
                    )
                  "
                >
                  {{
                    formatPriority(
                      selectedSubmissionDetails.submission.priority
                    )
                  }}
                </span>
              </div>
            </div>
          </div>

          <div class="details-section">
            <h4>Message</h4>
            <div class="message-content">
              {{ selectedSubmissionDetails.submission.message }}
            </div>
          </div>

          <div
            class="details-section"
            *ngIf="selectedSubmissionDetails.responses.length > 0"
          >
            <h4>
              Conversation History ({{
                selectedSubmissionDetails.responses.length
              }})
            </h4>
            <div class="responses-section">
              <div
                *ngFor="let response of selectedSubmissionDetails.responses"
                class="response-item"
                [ngClass]="{
                  'admin-response': response.response_author_type === 'admin',
                  'user-response':
                    response.response_author_type === 'user' ||
                    response.response_author_type === 'user_legacy',
                  'system-response': response.response_author_type === 'system'
                }"
              >
                <div class="response-header">
                  <div class="response-author">
                    <strong>
                      {{ getResponseAuthorDisplay(response) }}
                    </strong>
                    <span
                      class="response-type-badge"
                      [ngClass]="getResponseTypeBadgeClass(response)"
                    >
                      {{ getResponseTypeLabel(response) }}
                    </span>
                  </div>
                  <span class="response-date">
                    {{ formatDate(response.created_at) }}
                  </span>
                </div>

                <div class="response-content">
                  <p>{{ getResponseText(response) }}</p>

                  <div *ngIf="response.email_subject" class="email-subject">
                    <strong>Subject:</strong> {{ response.email_subject }}
                  </div>

                  <div
                    *ngIf="
                      response.response_type === 'email' &&
                      response.is_sent_to_customer
                    "
                    class="email-status"
                  >
                    <span
                      *ngIf="response.email_sent_successfully"
                      class="status-success"
                    >
                      ✓ Email sent successfully
                    </span>
                    <span
                      *ngIf="response.email_sent_successfully === false"
                      class="status-error"
                    >
                      ✗ Email failed: {{ response.email_error_message }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="details-section"
            *ngIf="selectedSubmissionDetails.submission.internal_notes"
          >
            <h4>Internal Notes</h4>
            <div class="internal-notes">
              {{ selectedSubmissionDetails.submission.internal_notes }}
            </div>
          </div>
        </div>
      </div>

      <div class="modal-actions">
        <button
          class="btn-modal cancel"
          (click)="closeSubmissionDetailsModal()"
        >
          Close
        </button>
        <button
          class="btn-modal primary"
          (click)="
            respondToSubmission(selectedSubmissionDetails.submission);
            closeSubmissionDetailsModal()
          "
        >
          Add Response
        </button>
      </div>
    </div>
  </div>
</div>
